export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "sellers_customers",
      layout: "dashboard",
    },
    path: "/seller-customers",
    name: "seller-customers",
    component: () => import("@/layouts/index/SellerCustomerIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de clients vendeurs",
          layout: "dashboard",
        },
        path: "index",
        name: "seller-customers-index",
        component: () => import("@/views/seller-customers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un client vendeur",
          layout: "dashboard",
        },
        path: "create",
        name: "seller-customers-create",
        component: () => import("@/views/seller-customers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le client vendeur",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "seller-customers-edit",
        component: () => import("@/views/seller-customers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du client vendeur",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "seller-customers-details",
        component: () => import("@/views/seller-customers/Details.vue"),
      },
    ],
  },
];
